<template>
  <div class="table-wrapper shadow-muted-super mt-2">
    <b-overlay :show="isLoading" rounded="sm" spinner-variant="primary" opacity="0.6">
      <b-table
        @row-selected="onRowSelected"
        selectable
        :fields="visibleFields"
        :items="items"
        ref="theTable"
        class="bg-white shadow-muted-super sum-header mb-0"
        head-variant="light"
        no-border-collapse
        small
        :sticky-header="tableHeight"
        :filter="AppState.cnrSearchText"
        show-empty
        @row-clicked="
          item => {
            navigateTo(item);
          }
        "
        tbody-tr-class="action-button"
        @filtered="filteredItems => recalcSumHeaders(filteredItems)"
      >
        <template #head(checked)>
          <b-form-checkbox
            :disabled="items.length == 0"
            v-model="checkedAllTableEntries"
            @change="onCheckAllTableEntries"
          ></b-form-checkbox>
        </template>
        <!--<template
          v-slot:[`head(${summaryField})`]="data"
          v-for="summaryField in fields.filter(x => x.sumHeader == true).map(y => y.key)"
        >
          <div :key="summaryField">
            <div style="padding-right: 2px">
              {{ data.label }}
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': AppState.cnrSearchText != '' }"
            >
              <b-icon icon="funnel-fill" v-if="AppState.cnrSearchText != ''" />
              {{ $utils.formatCurrency(data.field.sum, SettingsStore) }}
            </div>
          </div>
        </template>-->
        <template #head(BudgetSaldo)="data">
          <div style="padding-right: 2px">
            <div style="padding-right: 2px">
              {{ data.label }}
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': AppState.cnrSearchText !== '' }"
            >
              <b-icon icon="funnel-fill" v-if="AppState.cnrSearchText !== ''" />
              {{ $utils.formatCurrency(SumBudgetSaldo, SettingsStore) }}
            </div>
          </div>
        </template>
        <template #head(LVPreis)="data">
          <div style="padding-right: 2px">
            <div style="padding-right: 2px">
              {{ data.label }}
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': AppState.cnrSearchText != '' }"
            >
              <b-icon icon="funnel-fill" v-if="AppState.cnrSearchText != ''" />
              {{ $utils.formatCurrency(SumLVPreis, SettingsStore) }}
            </div>
          </div>
        </template>
        <template #head(LVPreisAbw)="data">
          <div style="padding-right: 2px">
            <div style="padding-right: 2px">
              {{ data.label }}
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': AppState.cnrSearchText != '' }"
            >
              <b-icon icon="funnel-fill" v-if="AppState.cnrSearchText != ''" />
              {{ $utils.formatCurrency(SumLVPreisAbw, SettingsStore) }}
            </div>
          </div>
        </template>
        <template #head(ActiveQuoteAmount)="data">
          <div style="padding-right: 2px">
            <div style="padding-right: 2px">
              {{ data.label }}
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': AppState.cnrSearchText != '' }"
            >
              <b-icon icon="funnel-fill" v-if="AppState.cnrSearchText != ''" />
              {{ $utils.formatCurrency(SumActiveQuoteAmount, SettingsStore) }}
            </div>
          </div>
        </template>
        <template #head(APAbw)="data">
          <div style="padding-right: 2px">
            <div style="padding-right: 2px">
              {{ data.label }}
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': AppState.cnrSearchText != '' }"
            >
              <b-icon icon="funnel-fill" v-if="AppState.cnrSearchText != ''" />
              {{ $utils.formatCurrency(SumAPAbw, SettingsStore) }}
            </div>
          </div>
        </template>
        <template #head(AmountSaldo)="data">
          <div style="padding-right: 2px">
            <div style="padding-right: 2px">
              {{ data.label }}
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': AppState.cnrSearchText != '' }"
            >
              <b-icon icon="funnel-fill" v-if="AppState.cnrSearchText != ''" />
              {{ $utils.formatCurrency(SumAmountSaldo, SettingsStore) }}
            </div>
          </div>
        </template>
        <template #head(Chancen)="data">
          <div style="padding-right: 2px">
            <div style="padding-right: 2px">
              {{ data.label }}
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': AppState.cnrSearchText != '' }"
            >
              <b-icon icon="funnel-fill" v-if="AppState.cnrSearchText != ''" />
              {{ $utils.formatCurrency(SumChancen, SettingsStore) }}
            </div>
          </div>
        </template>
        <template #head(ChancenPrognose)="data">
          <div style="padding-right: 2px">
            <div style="padding-right: 2px">
              {{ data.label }}
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': AppState.cnrSearchText != '' }"
            >
              <b-icon icon="funnel-fill" v-if="AppState.cnrSearchText != ''" />
              {{ $utils.formatCurrency(SumChancenPrognose, SettingsStore) }}
            </div>
          </div>
        </template>
        <template #head(Risiken)="data">
          <div style="padding-right: 2px">
            <div style="padding-right: 2px">
              {{ data.label }}
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': AppState.cnrSearchText != '' }"
            >
              <b-icon icon="funnel-fill" v-if="AppState.cnrSearchText != ''" />
              {{ $utils.formatCurrency(SumRisiken, SettingsStore) }}
            </div>
          </div>
        </template>
        <template #head(RisikenPrognose)="data">
          <div style="padding-right: 2px">
            <div style="padding-right: 2px">
              {{ data.label }}
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': AppState.cnrSearchText != '' }"
            >
              <b-icon icon="funnel-fill" v-if="AppState.cnrSearchText != ''" />
              {{ $utils.formatCurrency(SumRisikenPrognose, SettingsStore) }}
            </div>
          </div>
        </template>
        <template #head(Total)="data">
          <div style="padding-right: 2px">
            <div style="padding-right: 2px">
              {{ data.label }}
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': AppState.cnrSearchText != '' }"
            >
              <b-icon icon="funnel-fill" v-if="AppState.cnrSearchText != ''" />
              {{ $utils.formatCurrency(SumTotal, SettingsStore) }}
            </div>
          </div>
        </template>
        <template #head(TotalPrognose)="data">
          <div style="padding-right: 2px">
            <div style="padding-right: 2px">
              {{ data.label }}
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': AppState.cnrSearchText != '' }"
            >
              <b-icon icon="funnel-fill" v-if="AppState.cnrSearchText != ''" />
              {{ $utils.formatCurrency(SumTotalPrognose, SettingsStore) }}
            </div>
          </div>
        </template>
        <template #head(actions)="data">
          {{ data.label }}
          <span @click="$bvModal.show('risksVEList')" role="button">
            <b-icon icon="three-dots-vertical" class="float-right no-outline" style="margin-top: 4px" />
          </span>
          <!--
          <b-modal
            cancel-disabled
            ok-disabled
            hide-footer
            hide-backdrop
            hide-header
            no-fade
            id="risk-column-selector-modal"
            body-class="p-0"
            content-class="border-0"
          >
            <b-list-group>
              <b-list-group-item v-for="item in fields.filter(x => x.hideable == true)" :key="item.key" class="p-2">
                <b-form-checkbox
                  @change="onClickColumnVisible(item)"
                  v-model="item.visible"
                  value="true"
                  unchecked-value="false"
                >
                  {{ item.label }}
                </b-form-checkbox>
              </b-list-group-item>
            </b-list-group>
          </b-modal>-->
        </template>
        <template #cell(checked)="data">
          <b-form-checkbox
            @change="checked(data)"
            v-model="data.rowSelected"
            :disabled="data.item.editMode"
          ></b-form-checkbox>
        </template>
        <template #cell(KGR)="data">
          <div class="text-nowrap" @click.stop="navigateTo(data.item)">{{ data.item.KGR || '&nbsp;' }}</div>
        </template>
        <template #cell(Active)="data">
          <div>
            <b-form-checkbox
              v-model="data.item.CnRActive"
              name="check-button"
              switch
              @change="updateCnRActiveFlag(data.item)"
            />
          </div>
        </template>
        <template #cell(FA1)="data">
          <div class="text-nowrap" @click.stop="navigateTo(data.item)">{{ data.value || '&nbsp;' }}</div>
        </template>
        <template #cell(actions)="data">
          <b-icon
            class="action-button text-grey"
            style="width: 18px; height: 18px"
            icon="card-list"
            title="Chancen & Risiken"
            @click.stop="navigateTo(data.item)"
          />
        </template>
      </b-table>
    </b-overlay>
    <TableColumnSelector
      :fields="fields"
      id="risksVEList"
      @ok="AppState.updateVisibleFields('risksVEList', fields)"
    ></TableColumnSelector>
  </div>
</template>

<script>
import AppState from '@/store/App.js';
import SettingsStore from '@/store/Settings';
import RisksService from '@/service/RisksService';
import TableColumnSelector from '@/components/TableColumnSelector';

export default {
  async activated() {
    AppState.loadVisibleFields('risksVEList', this.fields);
    AppState.cnrSearchText = AppState.cnrSearchTextVe;
    AppState.currentCnRVE = null;
    AppState.isLoading = false;
    this.isLoading = true;
    this.$eventBus.$emit('CnR:filterReset', this.filterEnabled);
    this.items = await RisksService.getAllVE();

    if (AppState.scrollPosition[this.$route.path])
      this.$refs.theTable.$el.scrollTo({
        top: AppState.scrollPosition[this.$route.path][0],
        left: AppState.scrollPosition[this.$route.path][1]
      });

    this.$eventBus.$on('CnR:header:toggle', this.onWindowResize);
    this.$eventBus.$on('CnR:filter', this.handleFilter);

    this.$eventBus.$emit('CnR:rowsSelected', this.selectedRows);

    if (this.selectedRows.length > 0 && this.filterEnabled) {
      this.items = this.selectedRows;
      this.$refs.theTable.selectAllRows();
    } else {
      this.$refs.theTable.clearSelected();
      this.selectedRows.forEach(row => {
        this.$nextTick(() => {
          this.$refs.theTable.selectRow(this.items.findIndex(item => row.VeDbId == item.VeDbId));
        });
      });
    }

    this.recalcSumHeaders(this.items);
    window.addEventListener('resize', this.onWindowResize); // listen for windows size changes, to re-compute height of controls
    this.onWindowResize();

    this.$nextTick(() => (this.isLoading = false));
  },
  deactivated() {
    window.removeEventListener('resize', this.onWindowResize);
    AppState.cnrSearchTextVe = AppState.cnrSearchText;
    this.$eventBus.$off('CnR:header:toggle', this.onWindowResize);
    this.$eventBus.$off('CnR:filter', this.handleFilter);
  },
  components: {
    TableColumnSelector
  },
  data() {
    return {
      SettingsStore,
      checkedAllTableEntries: false,
      filterEnabled: false,
      searchText: '',
      tableHeight: '500px',
      isLoading: true,
      AppState,
      SumBudgetSaldo: 0.0,
      SumLVPreis: 0.0,
      SumLVPreisAbw: 0.0,
      SumActiveQuoteAmount: 0.0,
      SumAPAbw: 0.0,
      SumAmountSaldo: 0.0,
      SumChancen: 0.0,
      SumChancenPrognose: 0.0,
      SumRisiken: 0.0,
      SumRisikenPrognose: 0.0,
      SumTotal: 0.0,
      SumTotalPrognose: 0.0,
      fields: [
        {
          hideable: false,
          visible: true,
          key: 'checked',
          label: '',
          tdClass: 'sticky-col first-col text-center align-middle',
          thClass: 'sticky-col first-col text-center align-top noselect',
          thStyle: 'z-index: 10;'
        },
        {
          hideable: false,
          visible: true,
          key: 'Ordinal',
          label: 'VE',
          thClass: 'align-top sticky-col second-col',
          tdClass: 'sticky-col second-col',
          sortable: true,
          thStyle: 'z-index: 10;'
        },
        {
          visible: true,
          hideable: false,
          key: 'DisplayName',
          label: 'Bezeichnung',
          thClass: 'align-top sticky-col third-col',
          tdClass: 'sticky-col third-col',
          sortable: true,
          thStyle: 'z-index: 10;'
        },
        {
          hideable: false,
          visible: true,
          key: 'ProcessStatus',
          label: 'Status',
          sortable: true,
          thClass: 'align-top sticky-col fourth-col',
          tdClass: 'sticky-col fourth-col',
          thStyle: 'z-index: 10;'
        },
        {
          hideable: false,
          visible: true,
          key: 'BudgetSaldo',
          label: 'VE-Budget',
          tdClass: 'bg-light text-right text-nowrap sticky-col fifth-col',
          sortable: true,
          sumHeader: true,
          sum: 0.0,
          thClass: 'align-top text-right text-nowrap sticky-col fifth-col',
          thStyle: 'padding-right: 12px;z-index: 10;',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore)
        },
        {
          hideable: SettingsStore.settings['KGR_Selections_Active'] == 'true',
          visible: SettingsStore.settings['KGR_Selections_Active'] == 'true',
          key: 'KGR',
          label: 'Kostengruppe',
          sortable: true,
          thClass: 'align-top'
        },
        {
          hideable: true,
          visible: true,
          key: 'Responsible',
          label: 'Verantwortlich',
          sortable: true,
          thClass: 'align-top'
        },
        {
          hideable: true,
          visible: true,
          key: 'FA1',
          label: SettingsStore.settings['FA1'],
          sortable: true,
          thClass: 'align-top'
        },
        {
          hideable: true,
          visible: true,
          key: 'FA2',
          label: SettingsStore.settings['FA2'],
          sortable: true,
          thClass: 'align-top'
        },

        {
          hideable: true,
          visible: true,
          key: 'LVPreis',
          label: 'LV-Preis',
          tdClass: 'bg-primary-light text-right text-nowrap',
          sortable: true,
          sumHeader: true,
          sum: 0.0,
          thClass: 'align-top text-right text-nowrap',
          thStyle: 'padding-right: 12px;',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore)
        },
        {
          hideable: true,
          visible: true,
          key: 'LVPreisAbw',
          label: 'Abweichung Budget',
          tdClass: 'bg-primary-light text-right text-nowrap',
          sortable: true,
          sumHeader: true,
          sum: 0.0,
          thClass: 'align-top text-right text-nowrap',
          thStyle: 'padding-right: 12px;',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore)
        },
        {
          hideable: true,
          visible: true,
          key: 'ActiveQuoteAmount',
          label: 'Angebotspreis',
          tdClass: 'bg-primary-light-2 text-right text-nowrap',
          sortable: true,
          sumHeader: true,
          sum: 0.0,
          thClass: 'align-top text-right text-nowrap',
          thStyle: 'padding-right: 12px;',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore)
        },
        {
          hideable: true,
          visible: true,
          key: 'APAbw',
          label: 'Abweichung Budget',
          tdClass: 'bg-primary-light-2 text-right text-nowrap',
          sortable: true,
          sumHeader: true,
          sum: 0.0,
          thClass: 'align-top text-right text-nowrap',
          thStyle: 'padding-right: 12px;',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore)
        },
        {
          hideable: true,
          visible: true,
          key: 'AmountSaldo',
          label: 'Gesamtauftrag',
          tdClass: 'bg-primary-light-3 text-right text-nowrap',
          sortable: true,
          sumHeader: true,
          sum: 0.0,
          thClass: 'align-top text-right text-nowrap',
          thStyle: 'padding-right: 12px;',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore)
        },
        {
          hideable: true,
          visible: true,
          key: 'NachtragsBudget',
          label: 'Nachtragsbudget',
          tdClass: 'bg-primary-light-3 text-right',
          sortable: true,
          thClass: 'align-top text-right',
          thStyle: 'padding-right: 12px;',
          formatter: (k, v, item) => {
            return this.$utils.formatCurrency(item.BudgetSaldo - item.AmountSaldo, SettingsStore);
          }
        },
        {
          hideable: true,
          visible: true,
          key: 'Invoiced',
          label: 'Abgerechnet',
          sortable: true,
          thClass: 'align-top text-right',
          tdClass: 'bg-primary-light-4 text-right',
          thStyle: 'padding-right: 12px;',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore)
        },
        {
          hideable: true,
          visible: true,
          key: 'ObligoAmount',
          label: 'Obligo',
          sortable: true,
          thClass: 'align-top text-right',
          tdClass: 'bg-primary-light-4 text-right',
          thStyle: 'padding-right: 12px;',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore)
        },
        {
          hideable: false,
          visible: true,
          key: 'Active',
          label: 'Aktiv',
          sortable: true,
          thClass: 'align-top',
          thStyle: 'padding-right: 12px;',
          tdClass: 'text-center'
        },
        {
          hideable: true,
          visible: true,
          key: 'Chancen',
          label: 'Chancen',
          //tdClass: 'bg-light text-right text-nowrap',
          tdClass: (type, key, item) => {
            if (item.CnRActive == true) return 'bg-light text-right text-nowrap';
            return 'bg-light text-right text-nowrap text-grey-2';
          },
          sortable: true,
          sumHeader: true,
          sum: 0.0,
          thClass: 'align-top text-right',
          thStyle: 'padding-right: 12px;',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore)
        },
        {
          hideable: true,
          visible: true,
          key: 'ChancenPrognose',
          label: '(C-prognoserelevant)',
          tdClass: (type, key, item) => {
            if (item.CnRActive == true) return 'bg-light-2 text-right text-nowrap';
            return 'bg-light-2 text-right text-nowrap text-grey-2';
          },
          sortable: true,
          sumHeader: true,
          sum: 0.0,
          thClass: 'align-top text-right text-nowrap',
          thStyle: 'padding-right: 12px;',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore)
        },
        {
          hideable: true,
          visible: true,
          key: 'Risiken',
          label: 'Risiken',
          tdClass: (type, key, item) => {
            if (item.CnRActive == true) return 'bg-light text-right text-nowrap';
            return 'bg-light text-right text-nowrap text-grey-2';
          },
          sortable: true,
          sumHeader: true,
          sum: 0.0,
          thClass: 'align-top text-right',
          thStyle: 'padding-right: 12px;',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore)
        },
        {
          hideable: true,
          visible: true,
          key: 'RisikenPrognose',
          label: '(R-prognoserelevant)',
          tdClass: (type, key, item) => {
            if (item.CnRActive == true) return 'bg-light-2 text-right text-nowrap';
            return 'bg-light-2 text-right text-nowrap text-grey-2';
          },
          sortable: true,
          sumHeader: true,
          sum: 0.0,
          thClass: 'align-top text-right text-nowrap',
          thStyle: 'padding-right: 12px;',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore)
        },
        {
          hideable: true,
          visible: true,
          key: 'Total',
          label: 'Gesamt',
          tdClass: (type, key, item) => {
            if (item.CnRActive == true) return 'bg-light text-right text-nowrap';
            return 'bg-light text-right text-nowrap text-grey-2';
          },
          sortable: true,
          sumHeader: true,
          sum: 0.0,
          thClass: 'align-top text-right',
          thStyle: 'padding-right: 12px;',
          //formatter: (k, v, item) => this.$utils.formatCurrency(item.Risiken - item.Chancen, SettingsStore)
          formatter: x => this.$utils.formatCurrency(x, SettingsStore)
        },
        {
          hideable: true,
          visible: true,
          key: 'TotalPrognose',
          label: '(prognoserelevant)',
          tdClass: (type, key, item) => {
            if (item.CnRActive == true) return 'bg-light-2 text-right text-nowrap';
            return 'bg-light-2 text-right text-nowrap text-grey-2';
          },
          sortable: true,
          sumHeader: true,
          sum: 0.0,
          thClass: 'align-top text-right',
          thStyle: 'padding-right: 12px;',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore)
        },
        {
          hideable: false,
          visible: true,
          key: 'actions',
          label: 'Aktionen',
          tdClass: 'sticky-col last-col text-center align-middle',
          thClass: 'sticky-col last-col align-top noselect',
          thStyle: 'z-index: 10'
        }
      ],
      items: [],
      selectedRows: []
    };
  },
  methods: {
    async updateCnRActiveFlag(item) {
      this.recalcSumHeaders(this.items);
      await RisksService.updateCnRActiveFlag(item);
      this.$eventBus.$emit('CnR:deleted');
    },
    recalcSumHeaders(items) {
      this.SumBudgetSaldo = 0.0;
      this.SumLVPreis = 0.0;
      this.SumLVPreisAbw = 0.0;
      this.SumActiveQuoteAmount = 0.0;
      this.SumAPAbw = 0.0;
      this.SumAmountSaldo = 0.0;
      this.SumChancen = 0.0;
      this.SumChancenPrognose = 0.0;
      this.SumRisiken = 0.0;
      this.SumRisikenPrognose = 0.0;
      this.SumTotal = 0.0;
      this.SumTotalPrognose = 0.0;
      items.map(x => {
        this.SumBudgetSaldo += x.BudgetSaldo;
        this.SumLVPreis += x.LVPreis;
        this.SumLVPreisAbw += x.LVPreisAbw;
        this.SumActiveQuoteAmount += x.ActiveQuoteAmount;
        this.SumAPAbw += x.APAbw;
        this.SumAmountSaldo += x.AmountSaldo;
        this.SumChancen += x.Chancen;
        this.SumChancenPrognose += x.ChancenPrognose;
        this.SumRisiken += x.Risiken;
        this.SumRisikenPrognose += x.RisikenPrognose;
        this.SumTotal += x.Total;
        this.SumTotalPrognose += x.TotalPrognose;
      });
    },
    onWindowResize() {
      const totalHeight = window.innerHeight;
      const headerSummarySection = this.$parent.$refs.CnRSummarySection;

      const tableHeight = totalHeight - headerSummarySection.offsetHeight - 180;
      this.tableHeight = tableHeight + 'px';
    },

    navigateTo(item) {
      AppState.currentCnRVE = item;
      this.$router.push({ name: 'Chancen & Risiken Details', params: { id: item.VeDbId, item } });
    },
    onCheckAllTableEntries() {
      if (this.checkedAllTableEntries) {
        this.$refs.theTable.selectAllRows();
      } else {
        this.$refs.theTable.clearSelected();
      }
    },
    onClickColumnVisible() {
      AppState.updateVisibleFields('risksVEList', this.fields);
    },
    conditionalColor() {
      return 'text-center';
    },
    checked(data) {
      if (data.rowSelected) {
        this.$refs.theTable.selectRow(data.index);
      } else {
        this.$refs.theTable.unselectRow(data.index);
      }
    },
    onRowSelected(selectedItems) {
      this.selectedRows = selectedItems;
      this.$eventBus.$emit('CnR:rowsSelected', this.selectedRows);
      if (selectedItems.length < this.items.length) {
        this.checkedAllTableEntries = false;
      } else {
        this.checkedAllTableEntries = true;
      }
    },
    handleFilter(filterEnabled) {
      this.filterEnabled = filterEnabled;
      if (filterEnabled) {
        this.itemsBackup = [...this.items];
        this.items = this.selectedRows;
        this.$nextTick(() => {
          this.$refs.theTable.selectAllRows();
        });
      } else {
        this.items = this.itemsBackup;

        this.selectedRows.forEach(row => {
          this.$nextTick(() => {
            this.$refs.theTable.selectRow(this.items.findIndex(item => row.VeDbId == item.VeDbId));
          });
        });
      }
      this.recalcSumHeaders(this.items);
    }
  },
  computed: {
    visibleFields() {
      return this.fields.filter(field => field.visible == true || field.visible == 'true');
    }
  },
  beforeRouteLeave(to, from, next) {
    //console.log('zzz RiskVE to', to, this.$refs.theTable.$el.scrollTop);

    AppState.cnRVETableScrollPosition = this.$refs.theTable.$el.scrollTop;
    AppState.cnRVETableScrollPositionLeft = this.$refs.theTable.$el.scrollLeft;

    AppState.scrollPosition[from.path] = [this.$refs.theTable.$el.scrollTop, this.$refs.theTable.$el.scrollLeft];
    //console.log('zzz AppState.scrollPosition', AppState.scrollPosition);
    next();
  }
};
</script>

<style>
.first-col {
  width: 50px;
  min-width: 50px;
  max-width: 50px;
  left: 0;
}
.second-col {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
  left: 50px;
}

.third-col {
  width: 220px;
  min-width: 220px;
  max-width: 220px;
  left: 150px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.fourth-col {
  width: 120px;
  min-width: 120px;
  max-width: 120px;
  left: 370px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.fifth-col {
  width: 140px;
  min-width: 140px;
  max-width: 140px;
  left: 490px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.last-col {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
  right: 0;
}
.table-wrapper tbody tr td.sticky-col {
  background-color: var(--bauvisor-primary-light) !important;
}
.table-striped tbody tr:nth-of-type(odd) td.sticky-col {
  background-color: #efefef !important;
}
.table-striped tbody tr:nth-of-type(even) td.sticky-col {
  background-color: #f5f5f5 !important;
}
.table-wrapper td:not(:last-child) {
  border-right: 1px solid #dee2e6;
}
.table-wrapper td:last-child {
  border-left: 1px solid #ced2d6;
}
.table-wrapper td:nth-last-child(2) {
  border-left: none;
  border-right: none;
}
.table.b-table > tbody > .table-active,
.table.b-table > tbody > .table-active > th,
.table.b-table > tbody > .table-active > td {
  background-color: #f5f5f5;
}
#risk-column-selector-modal > .modal-dialog {
  position: absolute;
  top: 342px;
  right: 18px;
}
.custom-switch {
  padding-left: 2.9rem;
}
</style>
